<script lang='ts'>
    import { Icon, Table } from "sveltestrap";
    import type { Param } from "../Model/Param";
    import type { User } from "../Model/User";
    import AppWraper from "../components/AppWraper.svelte";
    import { paramsService, usersService } from "../services";
    import { error, success } from "../../public/my-theme";

    let userSigner: User;
    let users: User[] = [];
    let changeSigner = false;

    let opts = {
            offset : 0,
            limit : 25
        }

    $: loadUsers()
    $: loadSigner()

    async function loadSigner(): Promise<void> {
        userSigner = await usersService.findUserSigner();
    }

    async function loadUsers(): Promise<void> {
        users = await usersService.findAgents();
    }

    async function getName(id:string): Promise<string>{
        return await paramsService.findOne(id).then(param => param.name);
    }

    async function updateSigner(user: User) {
        try {
            if(!confirm('¿Seguro que quiere cambiar el firmante actual?')){
                return
            }

            user.signer = true;
            userSigner.signer = false;
            const resUser = await usersService.saveUser(user);
            const resSigner = await usersService.saveUser(userSigner);

            if(resUser && resSigner) {
                loadSigner();
                loadUsers();
                changeSigner = false;
                success('Se han guardado los cambios correctamente.')
            } else {
                error('Ha ocurrido un error al aplicar los cambios.')
                throw new Error('Ha ocurrido un error al aplicar los cambios.')
            }
        } catch(error) {
            console.log(error);
        }
    }
</script>

<AppWraper>
    <div class='container-fluid'>
        <div class="container">

            <div class="row mb-5">
                <div class="col-6">
                    <h3>Firmante</h3>
                </div>
                <div class='col-6 text-end'>
                    <button class='btn btn-success' on:click={() => changeSigner = true}>Cambiar firmante</button>
                </div>
            </div>

            <div class="row">
                <h5 class='mb-2'>Firmante actual</h5>
                <div class='col-12 p-4'>
                    {#if userSigner}
                        <table class='table'>
                            <thead>
                                <tr>
                                    <th>Nombre y apellidos</th>
                                    <th>Cargo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <span>
                                            {userSigner.name}
                                            {userSigner.surname1}
                                            {userSigner.surname2}
                                        </span>
                                    </td>
                                    <td>
                                        {userSigner.cargo}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    {/if}
                </div>
            </div>
            {#if changeSigner}
                <div class="row">
                    <h5 class='mb-2'>Escoja un nuevo firmante</h5>
                    <div class="col-12 p-4">
                        <Table hover>
                            <thead>
                                <th>Nombre y apellidos</th>
                                <th>Cargo</th>
                                <th></th>
                            </thead>
                            <tbody>
                                {#each users as user}
                                    {#if !user.signer && user.is_agent}
                                        <tr>
                                            <td>
                                                <span>
                                                    {user.name}
                                                    {user.surname1}
                                                    {user.surname2}
                                                </span>
                                            </td>
                                            <td>
                                                <span>
                                                    {user.cargo}
                                                </span>
                                            </td>
                                            <td>
                                                <button class="btn btn-success btn-sm bg-success" type='button' on:click={() => updateSigner(user)}>
                                                    <Icon name="check" />
                                                </button>
                                            </td>
                                        </tr>
                                    {/if}
                                {/each}
                            </tbody>
                        </Table>
                    </div>
                </div>
            {/if}
        </div>
    </div>
</AppWraper>